// Prism grammars used to color guide code blocks (see highlightCodeBlock in code-block.util.ts).
// The Prism core (markup, css, clike, javascript) is loaded by the apps; each grammar below
// registers itself on the global Prism, so dependencies are imported before the grammars using them.
import 'prismjs';
import 'prismjs/components/prism-markup-templating.min.js';
import 'prismjs/components/prism-bash.min.js';
import 'prismjs/components/prism-powershell.min.js';
import 'prismjs/components/prism-batch.min.js';
import 'prismjs/components/prism-json.min.js';
import 'prismjs/components/prism-yaml.min.js';
import 'prismjs/components/prism-scss.min.js';
import 'prismjs/components/prism-typescript.min.js';
import 'prismjs/components/prism-python.min.js';
import 'prismjs/components/prism-csharp.min.js';
import 'prismjs/components/prism-java.min.js';
import 'prismjs/components/prism-go.min.js';
import 'prismjs/components/prism-ruby.min.js';
import 'prismjs/components/prism-php.min.js';
import 'prismjs/components/prism-sql.min.js';
import 'prismjs/components/prism-kusto.min.js';
import 'prismjs/components/prism-docker.min.js';
import 'prismjs/components/prism-hcl.min.js';
import 'prismjs/components/prism-bicep.min.js';
